<template>
  <div>
    <div
      style="padding: 0 18px;display: flex;justify-content: space-between;align-items: center;height: 60px;width: 100%;position: fixed;top: 0;left: 0;box-sizing: border-box;background: #fff;border-bottom: 1px solid #CFD6EA;z-index: 99;">
      <img src="../../assets/mobile/logo2.png" style="width: 122px;height: 34px;" @click="goHome">
    </div>
    <div style="height: 60px;"></div>
    <div class="ListBanner">
      <div style="font-size: 22px;font-family: PingFangSC-Medium, PingFang SC;color: #1F2928;line-height: 30px;">日化标识码动态、资讯早知道</div>
      <div style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #808EA4;line-height: 17px;margin-top: 15px;">关注日化标识码最新动态，关注我们的每一次进步</div>
    </div>
    <div style="padding: 0 10px;box-sizing: border-box;margin-top: 20px;">
      <van-tabs v-model:active="active" @click="onClickTab">
        <van-tab title="营销干货"></van-tab>
        <van-tab title="企业动态"></van-tab>
        <van-tab title="使用指南"></van-tab>
        <van-tab title="客户案例"></van-tab>
        <van-tab title="更多文章"></van-tab>
      </van-tabs>
      <div>
        <div v-for="(item, index) in article" :key="index" style="padding: 12px;box-sizing: border-box;display: flex;justify-content: flex-start;align-items: center;" @click="toDetails(item.id)">
          <img :src="baseURL + item.image" style="min-width: 128px;min-height: 80px;max-width: 128px;max-height: 80px;">
          <div style="padding: 0 10px;">
            <div style="font-size: 15px;font-family: PingFangSC-Regular, PingFang SC;color: #36444D;line-height: 21px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2; -webkit-box-orient: vertical; ">{{item.title}}</div>
            <div style="display: flex;align-items: center;margin-top: 6px;">
              <img src="../../assets/images/time.png" style="width: 12px;height: 12px;margin-right: 5px;">
              <span style="font-size: 11px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;line-height: 22px;">{{item.publishTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    data() {
      return {
        active: 0,
        baseURL: '',
        article: [],
      }
    },
    methods: {
      
        goHome() {
          this.$router.push({
            path: '/mobile',
          })
        },
      toDetails(id) {
        this.$router.push({
          path: '/MobileNewsDetails',
          query: {
            id
          }
        })
      },
      onClickTab() {
        this.setArticle()
      },
      setArticle() {
        if (this.active == 4) {
          getArticle().then(res => {
            this.article = res.content
          })
        }else {
          var id = this.active + 1
          getArticle({
            type: id
          }).then(res => {
            this.article = res.content
          })
        }

      },
    },
    mounted() {
      this.baseURL = serverUrl.baseURL
      this.setArticle()
    }
  }
</script>
<style scoped>
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../assets/mobile/banner@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .ListBanner {
    height: 150px;width: 100%;
    background: url(../../assets/mobile/bj_5@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  /deep/ .van-tabs__line {
    background-color: #1ED2C7
  }

  /deep/ .van-tab {
    width: 100px;
    font-size: 15px;
  }

  /deep/ .van-tab--active {
    color: #03C5AE;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/MobileNewsList.vue